import InlineEdit from "@atlaskit/inline-edit";
import { FC } from "react";
import { TextField } from "../../UI/TextField";
import { ExtendedFieldProps } from "@atlaskit/inline-edit/dist/types/types";
import { Box } from "../../UI/Box";
import { COLOR_ATHENS_GRAY, COLOR_IRON, COLOR_COOL_GREY } from "../../constants/styles";
import { useUnitNumberHandler } from "./useUnitNumberHandler";
import { Skeleton } from "../../UI/Skeleton";

interface ITableUnitCellProps {
  unitId: number;
  unitNumber: string;
  isDisabled?: boolean;
}

const editView = ({ errorMessage, ...fieldProps }: ExtendedFieldProps<string>) => (
  <TextField {...fieldProps} autoFocus height={40} style={{ width: '48px' }} />
);

const readView = (value: string | null = "") => () => (
  <Box
    px={1}
    height={40}
    display="flex"
    alignItems="center"
    bgcolor={COLOR_ATHENS_GRAY}
    border={`1px solid ${COLOR_IRON}`}
  >
    {value}
  </Box>
);

const disabledReadView = (value: string | null = "") => (
  <Box width="48px">
    <Box
      px={1}
      height={40}
      display="flex"
      alignItems="center"
      bgcolor={COLOR_ATHENS_GRAY}
      border={`1px solid ${COLOR_IRON}`}
      sx={{ color: COLOR_COOL_GREY, cursor: 'default' }}
    >
      {value}
    </Box>
  </Box>
);

export const TableUnitCell: FC<ITableUnitCellProps> = ({ unitId, unitNumber, isDisabled }) => {
  const { updateHandler, isLoading } = useUnitNumberHandler(unitId);

  if (isLoading) {
    return <Skeleton variant="rectangular" height={40} width={48} />;
  }

  if (isDisabled) {
    return disabledReadView(unitNumber);
  }

  return (
    <Box width="48px">
      <InlineEdit
        keepEditViewOpenOnBlur
        readViewFitContainerWidth
        editView={editView}
        onConfirm={updateHandler}
        defaultValue={unitNumber}
        readView={readView(unitNumber)}
      />
    </Box>
  );
};
